import { render, staticRenderFns } from "./VOCuniformity.vue?vue&type=template&id=7b7525c6&scoped=true&"
import script from "./VOCuniformity.vue?vue&type=script&lang=js&"
export * from "./VOCuniformity.vue?vue&type=script&lang=js&"
import style0 from "./VOCuniformity.vue?vue&type=style&index=0&id=7b7525c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7525c6",
  null
  
)

export default component.exports